import React from 'react';


const CallButton = () => {
    return (
        <a className='p-btn-w' href="tel:+381615796175">
            <span className='p-ico'></span>
            +381615796175
        </a>
    );
};

export default CallButton;